import { request } from "../axios/request";

export const getFixedReadersService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/readers?setup=fixed", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getSingleFixedReadersService = (id = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/readers/" + id + "?setup=fixed", getState(), {
        method: "GET",
      })
    );
  };
};

export const getAllFixedReadersService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/readers?setup=fixed", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveFixedReaderService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/readers/" + id + "?setup=fixed", getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/readers?setup=fixed", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteFixedReaderService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/readers/" + id + "?setup=fixed/", getState(), {
        method: "DELETE",
      })
    );
  };
};
